<template>
    <div class="text-center text-xl align-middle max-w-main">
        <div class="flex justify-around  align-middle bg-footer bg-cover bg-center text-center pt-2 w-full font-main">
            <div @click="showIntroduce" class="flex-initial  max-h-8 inline-block" >
                <img class="max-h-6 inline-block" src="@/assets/default/1a.png" >
                <div class="ml-1 inline-block text-sm font-bold color-main">Giới thiệu</div>
            </div>
            <div @click="showQuestion" class="flex-initial inline-block  max-h-8" >

                <img class="max-h-6 inline-block" src="@/assets/default/2a.png" >
                <div class="ml-1 inline-block text-sm font-bold color-main">Hỏi đáp</div>
            </div>
            <div class=" flex-initial inline-block  max-h-8 ">
                <a href="https://vclick.vn/blog/">
                    <img class="max-h-6 inline-block" src="@/assets/default/3a.png" >
                    <div class="ml-1 inline-block text-sm font-bold color-main">Blog</div>
                </a>
            </div>
            <div class="flex-initial inline-block  max-h-8">
                <a href="tel:1900633337">
                    <img class="max-h-6 inline-block" src="@/assets/default/4a.png" >
                    <div class="ml-1 inline-block text-sm font-bold color-main">Hỗ trợ</div>
                </a>
            </div>
        </div>

        <b-modal id="bv-modal-introduce" centered hide-header hide-footer>
            <div class="d-block text-center">
                <div class="mt-2 font-bold color-main">
                    Giới thiệu Vclick
                    <!-- <div class="grid grid-cols-8 gap-4">
                        <div class="col-span-7 color-main" style="font-size: 18px;">
                            Giới thiệu Vclick
                        </div>
                        <div >
                            <b-icon @click="$bvModal.hide('bv-modal-introduce')"  scale="1" icon="x-lg" variant="secondary" ></b-icon>
                        </div>
                    </div> -->
                </div>
                <div class="mt-2 p-2 text-justify">
                    <div>
                        Vclick là Sàn tín dụng kết nối người cần vay với các ngân hàng và tổ chức tín dụng uy tín. 
                    </div>
                    <div class="mt-2">
                        Thông qua công nghệ đánh giá hiện tại, khách hàng sẽ tiếp cận khoản vay đơn giản và nhanh chóng hơn so với thông thường.
                    </div>
                    <div class="mt-2">
                        Vclick là sản phẩm của Công Ty Cổ Phần Đầu Tư Vega Fintech - đơn vị tiên phong tại áp dụng công nghệ AI, Big data nhằm tạo ra những sản phẩm, ứng dụng hàng đầu trong lĩnh vực tài chính, ngân hàng và bảo hiểm.
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="bv-modal-question" centered hide-header hide-footer>
            <div class="d-block text-center">
                <div class="mt-2 font-bold text-left">
                    <div class="grid grid-cols-8 gap-4">
                        <div class="col-span-8 text-center color-main" style="font-size: 18px;">
                            Hỏi đáp
                        </div>
                        <!-- <div >
                            <b-icon @click="$bvModal.hide('bv-modal-introduce')"  scale="1" icon="x-lg" variant="secondary" ></b-icon>
                        </div> -->
                    </div>
                </div>
                <div class="mt-2 p-2 text-justify">
                    <div class="border-main w-full rounded-lg">
                        <div class="relative rounded-md shadow-sm">
                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            <span class="color-main2 sm:text-sm"><b-icon icon="search"></b-icon></span>
                        </div>
                        <input type="text" @change="searchQuestion" v-model="search" name="price" id="price" class="block color-main2 w-full rounded-md pl-9 pr-4 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Tìm câu hỏi" />
                        <!-- <div class="absolute inset-y-0 right-2 flex items-center">
                            <button >Tìm kiếm</button>
                        </div> -->
                        </div>
                    </div>
                    <!-- <div class="mt-2">
                        <input class="border-main w-full rounded-lg" />
                    </div> -->
                    <div class="mt-4 border-main rounded-lg accordion grid grid-cols-1 divide-y divide-main-color h-80" role="tablist" style="overflow-y: scroll;">
                        <div v-for="(item,index) in dataQuestion" :key="index" >
                            <div class="font-bold color-main grid grid-cols-8 gap-4 p-2" role="tab" v-b-toggle="index +'_key'">
                                <div class="col-span-7">
                                    {{ item.name }}
                                </div>
                                <div>
                                    <b-icon  scale="1" icon="chevron-compact-right" variant="main-color" ></b-icon>
                                </div>
                            </div>
                            <b-collapse class="p-2" :id="index+'_key'" visible accordion="my-accordion" role="tabpanel">
                                {{ item.content }}
                            </b-collapse>
                        </div>
                        

                        <!-- <div class="font-bold color-main grid grid-cols-8 gap-4 mt-2 pt-1 pb-1" v-b-toggle.accordion-2>
                            <div class="col-span-7">
                                Thông qua công nghệ?
                            </div>
                            <div>
                                <b-icon  scale="1" icon="chevron-compact-right" variant="main-color" ></b-icon>
                            </div>
                        </div>
                        <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                            Thông qua công nghệ, Thông qua công nghệ, Thông qua công nghệ
                        </b-collapse>

                        <div class="font-bold color-main grid grid-cols-8 gap-4 mt-2 pt-1 pb-1" v-b-toggle.accordion-3>
                            <div class="col-span-7">
                                Thông qua công nghệ?
                            </div>
                            <div>
                                <b-icon  scale="1" icon="chevron-compact-right" variant="main-color" ></b-icon>
                            </div>
                        </div>
                        <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel">
                            Thông qua công nghệ, Thông qua công nghệ, Thông qua công nghệ
                        </b-collapse> -->

                        
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import {getFaq} from '@/api/otp'
import router from "@/router";
import subRoute from '@/router/subRoute'

export default {
    data() {
        return {
            search: '',
            dataAll: [],
            dataQuestion: [],
            baseUrl: window.location.origin + router.options.base,
        }
    },
    methods: {
        showIntroduce() {
            this.$bvModal.show('bv-modal-introduce')	
        },
        showQuestion() {
            this.$bvModal.show('bv-modal-question')
        },
        fetchQuestion() {
            getFaq({search: ''}).then(res => {
                //console.log(res)
                this.dataAll = res.data
                this.dataQuestion = res.data
            })
        },
        searchQuestion(){
            //console.log(this.dataAll.filter(e => e.content.includes(this.search)))
            this.dataQuestion = this.dataAll.filter(e => e.content.toLowerCase().includes(this.search.toLowerCase()) || e.name.toLowerCase().includes(this.search.toLowerCase()))
        },
        viewBlog() {
            let r = subRoute + 'blog'
            this.$router.push(r)
        }
    },
    created() {
        //this.baseUrl = window.location.origin + router.options.base
        //console.log(router)
        this.fetchQuestion()
    },
}
</script>